(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var GALLERY = 'card-gallery, .card-gallery, [class*="card-gallery"]';
    var queued = false;

    function placeBadges() {
      queued = false;
      document.querySelectorAll('.rating-badge[data-rb]').forEach(function (badge) {
        var card = badge.closest('product-card');
        var host = card && card.querySelector(GALLERY);
        if (!host) return;
        host.classList.add('rating-badge-host');
        host.appendChild(badge);
        badge.classList.add('is-placed');
        badge.removeAttribute('data-rb');
      });
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(placeBadges);
    }

    placeBadges();
    document.addEventListener('DOMContentLoaded', queue);
    document.addEventListener('shopify:section:load', queue);
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
